Application.Branding.Output = {
    ui: {
        container: '.step-output_branding',
        form: '.step-output_branding form',
        options: '.step-output_branding .el-selectable-box input',
        submit: '.step-output_branding .step-preview__submit',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // events
        $(this.ui.options).on('change', function (e) {
            self.update();
        });
        $(this.ui.form).on('submit', function (e) {
            if (!self.isOptionChecked()){
                e.preventDefault();
            }
        });

        // init
        this.update();

    },
    update: function(){

        $(this.ui.submit).toggleClass('btn_disabled', !this.isOptionChecked());

    },
    isOptionChecked: function () {

        var noOptionChecked = true;
        $(this.ui.options).each(function () {
            if ($(this).is(':checked')){
                noOptionChecked = false;
                return false;
            }
        });

        return !noOptionChecked;

    }
};